/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./favdigitaltwin.vue?vue&type=template&id=3a35cd09&scoped=true&"
import script from "./favdigitaltwin.vue?vue&type=script&lang=js&"
export * from "./favdigitaltwin.vue?vue&type=script&lang=js&"
import style0 from "./favdigitaltwin.vue?vue&type=style&index=0&id=3a35cd09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a35cd09",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
